import React, { Component } from 'react';
import Modal from '../../helpers/Modal';
import TextArea from '../../forms/TextArea';
import Button from '../../forms/Button';

class ReviewComment extends Component {
    constructor(props) {
        super(props);
        this.textAreaRef = React.createRef();
    }
    _addComment = () => this.props.addComment(this.props.elementId, this.props.comment);
    _inputComment = value => this.props.onComment(value);
    componentDidUpdate(prevProps) {
        if (this.props.isOpen && !prevProps.isOpen) {
            setTimeout(() => this.textAreaRef.current.focus(), 200);
        }
    }
    render() {
        const { close, disabled, isOpen, comment, savedComment } = this.props;
        return (
            <Modal onClose={close} className="is-big is-responsive" open={isOpen}>
                <h4 className="ckp-ts-h4 u-text-center u-margin-bottom-3">
                    {disabled ? 'Comment' : 'Add a comment to this section'}
                </h4>
                <TextArea
                    ref={this.textAreaRef}
                    disabled={disabled}
                    onChange={this._inputComment}
                    value={comment}
                    className="u-margin-bottom-2"
                />
                {disabled ? null : (
                    <p className="u-margin-bottom-1 u-text-center">
                        <Button
                            inactive={savedComment ? savedComment === comment : !comment}
                            onClick={this._addComment}
                            label={`${savedComment ? 'Update' : 'Add'} Comment`}
                            className="is-responsive"
                        />
                    </p>
                )}
                {disabled ? null : (
                    <p className="u-margin-bottom-1 u-text-center">
                        <a onClick={close} className="ckp-admin-modal-forms-button ckp-buttons-text is-warning">
                            Cancel
                        </a>
                    </p>
                )}
            </Modal>
        );
    }
}

export default ReviewComment;
